import { uploadFile } from "./upload";
import { FileWithPath } from "@mantine/dropzone";

export const assignFiles = async <T extends Record<string, File | null | string | FileWithPath>>(input: T, directory: string): Promise<{
    [K in keyof T]: string | undefined;
}> => {

    const result: Record<string, string | undefined> = {};

    for (const key in input) {
        const value = input[key];
        if (value instanceof File) {
            result[key] = await uploadFile(value, directory, key);
        } else if (typeof value === 'string') {
            result[key] = value;
        } else {
            result[key] = undefined;
        }
    }
    return result as { [K in keyof T]: string | undefined; };
}